// Core
import { AxiosResponse } from 'axios';
import { ActionCreator, AnyAction } from 'redux';

import { SagaIterator } from '@redux-saga/core';
import { call, put } from 'redux-saga/effects';

// Common types
import { ErrorActionType, FillActionType } from '../types/redux-types';
import { global_error_handler } from '../utils/global-error-handler';

export type OptionsType<T, D = void> = {
  fetcher: (uri?: any) => Promise<AxiosResponse<T>>;
  fetcherParam?: D;
  startFetching: ActionCreator<AnyAction>;
  stopFetching: ActionCreator<AnyAction>;
  fill: FillActionType<T>;
  setErrorAction: ErrorActionType;
  nextSaga?: (data: any) => any;
  dataGrid?: boolean;
};

/**
 *
 * @typeParam `T` response type
 * @typeParam `D` params payload type
 */

export function* makeRequestWithSpinner<T, D = void>(options: OptionsType<T, D>): SagaIterator {
  const { fetcher, fetcherParam, startFetching, stopFetching, fill, setErrorAction } = options;

  try {
    //if( process.env.NODE_ENV === 'development') console.log('test pratams___', fetcherParam)

    yield put(startFetching());

    const result: AxiosResponse<T> = yield call(fetcher, fetcherParam);

    /* if(process.env.NODE_ENV === 'development') {
            console.log('____________________')
            console.log('***********')
            console.log('____RESULT-FETCH____', result)
            console.log('***********')
            console.log('____________________')
        } */

    if (options.dataGrid) {
      //@ts-ignore
      yield put(fill(result.data.data));
    } else {
      yield put(fill(result.data));
    }

    if (options.nextSaga) {
      yield options.nextSaga(fetcherParam);
    }

    if (options.dataGrid) {
      //@ts-ignore
      return result.data.data;
    } else {
      return result.data;
    }
  } catch (error: any) {
    console.log('ERROR GLOBAL WORKET', error);
    yield put(setErrorAction(error.response));
    global_error_handler(error);
    throw error;
  } finally {
    yield put(stopFetching());
  }
}
